/* ברירות המחדל של הרכיבים הגלובליים.
   המראה של כל רכיב נקבע כאן פעם אחת — קומפוננטה לא מגדירה אותו מחדש. */
import { Button, Modal, Textarea, TextInput } from '@mantine/core';
import classes from './components.module.css';

export const components = {
  /* variant='default' משאיר ל-CSS שלנו לקבוע את הצבעים.
     variant='white' היה גוזר את צבע הטקסט מ-primaryColor ויוצר טקסט לבן על לבן. */
  Button: Button.extend({
    defaultProps: { radius: 'xl', size: 'md', variant: 'default' },
    classNames: (_theme, props) => ({
      root:
        props.variant === 'outline'
          ? `${classes.button} ${classes.buttonGhost}`
          : classes.button,
    }),
  }),
  TextInput: TextInput.extend({
    defaultProps: { radius: 'sm', size: 'md' },
    classNames: { input: classes.input, label: classes.inputLabel },
  }),
  Textarea: Textarea.extend({
    defaultProps: { radius: 'sm', size: 'md', minRows: 4, autosize: true },
    classNames: { input: classes.input, label: classes.inputLabel },
  }),
  Modal: Modal.extend({
    defaultProps: { centered: true, radius: 'lg', overlayProps: { blur: 6, opacity: 0.7 } },
    classNames: {
      content: classes.modalContent,
      header: classes.modalHeader,
      title: classes.modalTitle,
    },
  }),
};
